import styled from "@emotion/styled"
import { Container, Grid, Typography } from "@mui/material"
import Banner from "common/Banner"
import NextLink from "common/NextLink"
import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import ClockIcon from "common/icons/FirstClass/ClockIcon"
import MoneyIcon from "common/icons/FirstClass/MoneyIcon"
import PolicyIcon from "common/icons/FirstClass/PolicyIcon"
import ServiceIcon from "common/icons/FirstClass/ServiceIcon"
import SpreadIcon from "common/icons/FirstClass/SpreadIcon"
import TimeIcon from "common/icons/FirstClass/TimeIcon"
import TireIcon from "common/icons/FirstClass/TireIcon"
import WorkIcon from "common/icons/FirstClass/WorkIcon"
import nextLinks from "next.links"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    text-align: left; /* flipped by mui */
  `,
  Header: styled(Typography)`
    font-size: 34px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.white};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 54px;
    }
  `,
  Title: styled(Typography)`
    margin: 20px 0 0;
    font-size: 24px;
    font-weight: bold;
    text-align: left; /* flipped by mui */
    line-height: 1.17;
    color: ${(p) => p.theme.colors.marine};

    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 60px 0 0;
      line-height: 1;
      font-size: 28px;
    }
  `,
  Description: styled(Typography)`
    margin: 10px 0 30px;
    font-size: 14px;
    text-align: left; /* flipped by mui */
    color: ${(p) => p.theme.colors.marine};

    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 20px 0 40px;
      font-size: 18px;
    }
  `,
  Item: styled.div`
    display: flex;
    flex-direction: column;
    border: solid 1.5px #e6ecf0;
    align-items: center;
    justify-content: flex-start;
    padding: 20px 25px;
    height: 164px;

    svg {
      width: auto;
      height: 45px;
    }
  `,

  Label: styled(Typography)`
    margin-top: 10px;
    flex: 1;
    text-align: center;
    color: ${(p) => p.theme.colors.marine};
    line-height: 1.45;
    font-size: 20px;
  `,
  List: styled.div`
    overflow: hidden;
    margin: 38px 20px 47px;

    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 80px 0 60px;
      order: 4;
    }
  `,
  Content: styled.div`
    margin: 0 15px;
    display: flex;
    flex-direction: column;
    ${(p) => p.theme.breakpoints.down("sm")} {
      margin-bottom: 20px;
    }
  `,
}

export const getStaticProps = StaticPropsFactory("firstClass")

const FirstClass = ({ seo }: StaticPropsFactoryProps) => {
  const list = [
    { label: "נציג שירות אישי", icon: <ServiceIcon /> },
    { label: "קליטת רכב תוך 30 דק׳ בקביעת תור מראש", icon: <ClockIcon /> },
    { label: "התחייבות לעלויות וזמני טיפול מוגדרים", icon: <TimeIcon /> },
    { label: "גמישות בשעות העבודה", icon: <WorkIcon /> },
    {
      label: "הארכת אחריות לחלפים מקוריים ל-12 חודשים או 30,000 ק״מ",
      icon: <PolicyIcon />,
    },
    { label: "מחירי עבודה וחלפים אטרקטיביים", icon: <MoneyIcon /> },
    { label: "פריסה ארצית של מרכזי שירות", icon: <SpreadIcon /> },
    { label: "זמינות חלפים גבוהה ברשת מרכזי השירות", icon: <TireIcon /> },
  ]

  return (
    <Styled.Wrapper>
      <SeoMetaData data={seo} />
      <Banner
        url="/images/first-class_banner.jpg"
        title={<Styled.Header variant="h1">מחלקה ראשונה</Styled.Header>}
      />
      <Container disableGutters>
        <Styled.Content>
          <Styled.Title>
            שירות מהיר, זמין ומשתלם לרכבי עבודה במרכזי שירות מורשים
          </Styled.Title>
          <Styled.Description>
            {/* {`פריזה ארצית של מרכזי השירות - צריך להיות "פריסה ארצית של מרכזי
            שירות" זמינות חלפים - צריך להיות "זמינות חלפים גבוהה ברשת מרכזי
            השירות" להוריד את הכוכבית ממחירי עבודה וחלפים`} */}
          </Styled.Description>
          <Styled.List>
            <Grid container spacing={8}>
              {list.map((item, i) => (
                <Grid item key={i} md={3} sm={12} xs={12}>
                  <Styled.Item>
                    {item.icon}
                    <Styled.Label>{item.label}</Styled.Label>
                  </Styled.Item>
                </Grid>
              ))}
            </Grid>
          </Styled.List>
          <div>
            <NextLink href={nextLinks.serviceCenters} passHref>
              <Shared.Button variant="contained">
                מצא מרכז שירות קרוב
              </Shared.Button>
            </NextLink>
          </div>
        </Styled.Content>
      </Container>
    </Styled.Wrapper>
  )
}

export default FirstClass
